// src/utils/insurance-export.utils.ts

import type {
  Authorization,
  Claim,
  Enrollment,
  Policy,
  Provider,
} from "../contexts/InsuranceContextType";

export type InsuranceExportType =
  | "claims"
  | "policies"
  | "enrollments"
  | "all";

interface InsuranceExportData {
  claims: Claim[];
  policies: Policy[];
  enrollments: Enrollment[];
  authorizations: Authorization[];
  providers: Provider[];
}

interface ExportInsuranceDataParams {
  type: InsuranceExportType;
  claims: Claim[];
  policies: Policy[];
  enrollments: Enrollment[];
  authorizations: Authorization[];
  providers: Provider[];
}

const getExportPayload = ({
  type,
  claims,
  policies,
  enrollments,
  authorizations,
  providers,
}: ExportInsuranceDataParams):
  | Claim[]
  | Policy[]
  | Enrollment[]
  | InsuranceExportData => {
  switch (type) {
    case "claims":
      return claims;

    case "policies":
      return policies;

    case "enrollments":
      return enrollments;

    case "all":
      return {
        claims,
        policies,
        enrollments,
        authorizations,
        providers,
      };
  }
};

const getExportFilename = (
  type: InsuranceExportType
): string => {
  const date = new Date()
    .toISOString()
    .split("T")[0];

  return `insurance-${type}-${date}.json`;
};

export function exportInsuranceData(
  params: ExportInsuranceDataParams
): void {
  const payload = getExportPayload(params);

  const file = new Blob(
    [JSON.stringify(payload, null, 2)],
    {
      type: "application/json",
    }
  );

  const url = URL.createObjectURL(file);
  const link = document.createElement("a");

  link.href = url;
  link.download = getExportFilename(
    params.type
  );

  document.body.appendChild(link);
  link.click();
  link.remove();

  URL.revokeObjectURL(url);
}